<template>
  <div class="cloudSpatialInfo">
    <span class="cloudSpatialInfo-text">{{ $t('cloud_files') }}</span>
    <div class="cloudSpatialInfo-edit">
      <div class="uploadBtn">
        <el-button @click="uploadFile">
          <template>
            <div class="slot">
              <img src="@/assets/imgs/cloudSpace/uploadBtn.webp" alt="">
              <span class="slot-text">{{ $t('upload_file') }}</span>
            </div>
          </template>
        </el-button>
      </div>
      <div class="viewUpload">
        <img class="viewUpload-img" src="@/assets/imgs/cloudSpace/storageSpace.webp" alt="">
        <div class="viewUpload-info">
          <div class="viewUpload-info-text">
            {{ getUserUsed }}
          </div>
          <div class="viewUpload-info-progress">
            <el-progress :percentage="Number(user?.progress) > 100 ? 100 : Number(user?.progress) || 0" color="#3986FF"
              :show-text="false"></el-progress>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传 -->
    <el-upload ref="uploadFile" action="#" class="upload-resource" :show-file-list="false" style="display: none"
      :on-change="handleChange" :auto-upload="false" multiple accept=".3mf,.gcode,.stl,.obj,.step,.amf">
    </el-upload>
  </div>
</template>
<script>
import md5 from 'js-md5';
import axios from "axios";
import { mapState } from 'vuex'
import { lockStorageSpace, unlockStorageSpace, newUploadFile } from '@/api/network/printer'
import { Message } from 'element-ui'
import { configWrite } from '@/api/slicer/printer'
export default {
  name: "cloudSpatialInfo",
  props: {
    user: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      uploadGroupListShow: false,
      filePathName: "https://workbentch.s3.us-east-2.amazonaws.com/public/",
      timeProcessing: "0000/00/00/00/00/00",
      onQueue: false, //是否在上传
      uploadItems: [], //正在上传的数组
      uploadLen: 1, //上传文件个数限制
      uploadLine: 0, //上传文件线程
      uploadError: '',
      uploadlength: 0,
      uploadindex: 0,
    }
  },
  computed: {
    ...mapState({
      fileList: (state) => state.user.fileList,
    }),
    getUserUsed () {
      const { total, used } = this.user
      return `${used || 0} / ${total || 0}`
    },
  },
  watch: {
    // 监听上传队列数组上传完成触发代码
    "fileList": function (Newfile) {
      //当onQueue为true或上传数组为空时,不继续往下执行
      if (this.onQueue === true || Newfile.length === 0) return;

      let files = [...Newfile];

      //为了解决上传中失败,再选择文件,要手动重新上传的问题
      files = files.filter((item) => item.status !== "fail");

      //判断上传文件线程是否小于设置的上传文件个数限制
      if (this.uploadLine < this.uploadLen) {
        let newQueueLine = this.uploadLen - this.uploadLine;
        //截取剩余文件放入上传数组
        let index = this.uploadLine > 0 ? this.uploadLen - 1 : 0;
        this.uploadItems = files.splice(index, newQueueLine);
        this.uploadLimit(this.uploadItems);
      }
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.fileList.map((item) => {
        this.unlockStorageSpace(item.user_lock_space_id, 0);
      });
      this.$store.commit('SET_FILE_LIST', []);
    });
  },
  created () { },
  methods: {
    splitFileName (fileName) {
      // 获取文件类型
      const lastDotIndex = fileName.lastIndexOf('.');
      const fileType = fileName.substring(lastDotIndex + 1); // 取最后一个点之后的部分
      const name = fileName.substring(0, lastDotIndex); // 取最后一个点之前的部分

      return {
        fileName: name,
        fileType: fileType,
      };
    },
    BatchUnlock () {
      this.fileList.forEach((item, index) => {
        if (item.status === "fail") {
          this.unlockStorageSpace(item.user_lock_space_id, 0);
        }
      });
    },
    //重新上传
    handleReload (item) {
      this.BatchUnlock();
      //重置参数
      item.status = "ready";
      item.loaded = 0;
      item.percent = 0;
      item.speed = 0;
      this.onQueue = false; //是否在上传
      this.uploadItems = []; //正在上传的数组
      this.uploadLine = 0; //上传文件线程

      // 生成文件路径名称
      item.filePathName =
        this.filePathName + this.timeProcessing + this.md5Name(item.name);
      // 给文件加锁
      this.lockStorageSpace(item)
        .then((res) => {
          if (res.code === 1) {
            // 加锁接口获取id，url，上传url
            item.user_lock_space_id = res.data.id;
            item.url = res.data.url;
            item.preSignUrl = res.data.preSignUrl;
            //剔除文件
            let index = this.fileList.findIndex((it) => {
              return it.uid == item.uid;
            });
            const fileListNew = [...this.fileList]
            fileListNew.splice(index, 1)

            // this.$store.state.fileList.splice(index, 1);

            fileListNew.unshift(item);
            this.$store.commit('SET_FILE_LIST', fileListNew);
            configWrite('TransferUploadStatus', 1)
            return false;
          } else {
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //取消上传
    handleDel (item) {
      let index = this.fileList.findIndex((it) => {
        return it.uid == item.uid;
      });
      item.source?.cancel("取消请求")
      // this.$global.Storage.cancel(this.$store.state.fileList[index].upload);
      // this.$store.state.fileList.splice(index, 1);
      const fileListNew = [...this.fileList]
      fileListNew.splice(index, 1)
      this.$store.commit('SET_FILE_LIST', fileListNew);
      this.unlockStorageSpace(item.user_lock_space_id, 0);

      if (this.fileList.length === 0) {
        // 重置参数
        this.onQueue = false;
        this.uploadLen = 1; //上传文件个数限制
        this.uploadLine = 0; //上传文件线程
      }

      if (item.status === "uploading") {
        this.onQueue = false;
        this.uploadLine--;
      }
    },
    guid () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    //上传完成后的操作,无论此文件上传成功或失败，this.$store.state.fileList都进行删除此文件
    spliceUpload (file, is_delete_aws) {
      // file.source.cancel("取消请求")
      // 解锁空间
      this.unlockStorageSpace(file.user_lock_space_id, is_delete_aws);
      this.onQueue = false;
      let index = this.fileList.findIndex((item) => {
        return item.uid == file.uid;
      });
      const fileListNew = [...this.fileList]
      fileListNew.splice(index, 1)
      this.$store.commit('SET_FILE_LIST', fileListNew);
      // const a = [...this.fileList.splice(index, 1)];
      this.uploadItems.splice(index, 1);

      //删除该文件后，对应的上传文件线程-1
      this.uploadLine--;
    },
    //加锁
    lockStorageSpace (file) {
      file.raw.uid = file.raw.uid + new Date().getTime();
      file.uid = this.guid();
      return new Promise((resolve, reject) => {
        lockStorageSpace({
          name: file.name,
          size: file.size,
          is_temp_file: 0
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    //解锁
    unlockStorageSpace (id, is_delete) {
      unlockStorageSpace({
        id,
        is_delete_cos: is_delete
      })
        .then((res) => {
          this.getUserStore();
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },
    //提交文件
    submitUploadFile (file) {
      newUploadFile({
        user_lock_space_id: file.user_lock_space_id
      })
        .then((res) => {
          if (res.code === 1) {
            //提交完成
            // this.unlockStorageSpace(file.user_lock_space_id, 0);
            this.pageNum = 1;
            this.listData = [];
            this.getFilesList(false);
          } else {
            //提交失败
            file.status = "fail";
            //上传中取消,或者上传失败
            // this.unlockStorageSpace(file.user_lock_space_id, 1);
          }
          this.spliceUpload(file, 0);
        })
        .catch((err) => {
          // this.$message.error(err);
          this.spliceUpload(file, 0);
        });
    },
    //队列上传
    queueUpload (file) {
      // 如果文件状态不为ready则不可通过
      if (file.status !== "ready") {
        return;
      }

      let isSuccess = true;
      let failReason = "";
      this.onQueue = true;
      //开始上传该文件后，对应的上传文件线程+1
      this.uploadLine++;

      //上传文件至亚马逊
      let url = file.preSignUrl;
      let type = file.raw.type;
      // 为了可以取消请求
      file.source = axios.CancelToken.source();
      axios({
        method: "PUT",
        url,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: new Blob([file.raw], { type }),
        responseType: "blob",
        onUploadProgress: (info) => {
          // 进度更新
          var percent = parseInt((info.loaded / info.total) * 10000) / 100;
          var speed = parseInt((info.total / 1024 / 1024) * 100) / 100;
          file.loaded = info.loaded;
          Object.assign(file, { percent })
          // file.percent = percent;
          file.speed = speed;
          file.total = info.total;
          if (file.loaded === 0) {
            file.status = "ready";
          } else {
            file.status = "uploading";
          }
          const files = this.$store.state.user.fileList
          const index = files.findIndex(item => item.user_lock_space_id == file.user_lock_space_id)
          if (index != -1) {
            files[index] = file
            this.$store.commit('SET_FILE_LIST', []);
            this.$store.commit('SET_FILE_LIST', files);
          }


          this.$forceUpdate();
        },
        cancelToken: file.source.token,
      })
        .then((res1) => {
          this.submitUploadFile(file);
        })
        .catch((err) => {
          // 解锁空间
          this.unlockStorageSpace(file.user_lock_space_id, 0);
          //重置属性
          this.onQueue = false;
          let index = this.fileList.findIndex((item) => {
            return item.uid == file.uid;
          });
          this.uploadItems.splice(index, 1);
          //删除该文件后，对应的上传文件线程-1
          this.uploadLine--;
          failReason = err + "";
          file.status = "fail";
          this.$forceUpdate();
        });
    },
    //上传限制
    uploadLimit (items) {
      //遍历文件长度，就循环几次上传队列函数
      for (let item of items) {
        this.queueUpload(item);
      }
    },
    md5Name (name) {
      let leng = name.length;
      let index = name.lastIndexOf(".");
      let prefixName = name.substring(0, index);
      let suffixName = name.substring(index + 1, leng);
      return md5(prefixName) + "." + suffixName;
    },
    //上传之前进行判断,如uploadList的中有该文件,则不让添加进去
    beforeUpload (file) {
      //队列去重
      if (this.fileList.length == 0) {
        return true;
      }
      for (let item of this.fileList) {
        if (item.name == file.name) {
          return false;
        }
      }
      return true;
    },
    uploadFile () {
      const { total_bytes, used_bytes } = this.user
      if (used_bytes >= total_bytes && used_bytes) {
        // 原文:存储空间已满,请先删除文件列表中不需要的文件
        // 原文:提示
        // 原文:确定
        this.$alert(this.$t("storage_full_warning"), this.$t("tips"), {
          confirmButtonText: this.$t("OK"),
          callback: (action) => { },
          showClose: false,
          center: true
        });
      } else {
        this.$refs["uploadFile"].$children[0].$refs.input.click();
      }
    },
    //选择文件
    handleChange (file, files) {
      const { fileType } = this.splitFileName(file.name)
      //文件大小限制
      if (file.size > 2048 * 1024 * 1024) {
        // 原文:只支持上传2048M以内的模型文件，2048M以内的切片文件
        this.$message.error(this.$t("file_size_limit"));
        return;
      }

      //文件名长度限制
      let fileName = file.name;
      let index = fileName.lastIndexOf(".");
      let prefixName = fileName.substring(0, index);
      if (prefixName.length > 40) {
        prefixName = prefixName.slice(0, 40)
        file.name = prefixName + `.${fileType}`
      }

      //  文件格式限制
      const type = fileType.toLowerCase()
      const typeArr = ['3mf', 'gcode', 'stl', 'obj', 'step', 'amf']

      if (!typeArr.includes(type)) {
        // 原文:不符合的文件格式
        this.$message.error(
          this.$t("allowed_file_formats")
        );
        return
      }

      //上传前进行判断,如果上传列表中已经有该文件,则不让其添加进去
      let Repeat = this.beforeUpload(file);
      if (Repeat) {
        //文件过程限制结束,将文件添加进上传队列,触发上传,开始第一次队列上传
        this.uploadGroupListShow = true;
        file.loaded = 0;

        // this.$http
        //   .post("user/cloud_storage/getTcCosTempToken", {
        //     category: "stl",
        //     type: 2
        //   })
        //   .then((res_1) => {
        // if (res_1.code === 1) {
        // 生成文件路径名称
        file.filePathName =
          this.filePathName +
          this.timeProcessing +
          this.md5Name(file.name);
        // 给文件加锁
        this.lockStorageSpace(file)
          .then((res) => {
            if (res.code === 1) {
              // 加锁接口获取id，url，上传url
              file.user_lock_space_id = res.data.id;
              file.url = res.data.url;
              file.preSignUrl = res.data.preSignUrl;
              this.$store.commit('SET_FILE_LIST', [...this.fileList, file]);
              configWrite('TransferUploadStatus', 1)

              return false;
            } else {
              return false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
        // }
        // })
        // .catch((err) => {
        //   // this.$message.error(err);
        // });
      } else {
        this.$message.error(this.$t("RepeatUploadPrompt"));
      }
    },
  }
}
</script>
<style scoped lang="scss">
.cloudSpatialInfo {
  color: var(--first-text-color);
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 40px;

  &-text {
    margin-bottom: 8px;
  }

  &-edit {
    display: flex;
    justify-content: space-between;

    .uploadBtn {
      margin-top: 8px;

      .slot {
        display: flex;
        align-items: center;

        &-text {
          color: var(--first-text-color);
        }
      }
    }

    .viewUpload {
      padding: 9px 12px;
      display: flex;

      &-img {
        margin-right: 8px;
      }

      &-info {
        &-text {
          color: var(--VI-color);
          line-height: 22px;
          font-size: 15px;
          margin-bottom: 3px;
        }
      }
    }
  }
}
</style>